var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 141,
    viewBox: "0 0 230 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M109.549 4.26375C62.7539 -9.52705 52.6123 13.1401 51.3058 29.5745C49.9993 46.009 61.8128 50.506 49.7418 64.2975C37.6707 78.0889 11.4881 70.1893 3.02033 84.741C-5.44743 99.2927 1.02901 141 59.8934 141C118.758 141 223.688 134.563 229.679 95.8882C235.67 57.2134 156.344 18.0585 109.549 4.26375Z",
    fill: "#F2994A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.267 83.5223L119.684 53.0687C118.707 51.3754 116.956 50.3643 115 50.3643C113.045 50.3643 111.293 51.3754 110.316 53.0687L92.7333 83.5222C91.7556 85.2157 91.7556 87.2378 92.7333 88.9312C93.7111 90.6247 95.4621 91.6357 97.4177 91.6357H132.582C134.538 91.6357 136.289 90.6246 137.267 88.9313C138.244 87.2378 138.244 85.2157 137.267 83.5223ZM134.933 87.5838C134.442 88.4336 133.563 88.9408 132.582 88.9408H97.4177C96.4364 88.9408 95.5577 88.4336 95.0672 87.5838C94.5766 86.7341 94.5766 85.7196 95.0672 84.8698L112.65 54.4163C113.14 53.5666 114.019 53.0593 115 53.0593C115.981 53.0593 116.86 53.5666 117.35 54.4163L134.933 84.8698C135.423 85.7196 135.423 86.7341 134.933 87.5838Z",
    fill: "#F2994A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.347 63.8134H113.652V77.2883H116.347V63.8134Z",
    fill: "#F2994A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115 79.9834C114.009 79.9834 113.203 80.7894 113.203 81.7801C113.203 82.7708 114.009 83.5768 115 83.5768C115.99 83.5768 116.797 82.7708 116.797 81.7801C116.797 80.7894 115.991 79.9834 115 79.9834Z",
    fill: "#F2994A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.fe908be7.svg";
export { ForwardRef as ReactComponent };